import { useCallback } from "react";
import { DesignsDraftApi, useAPIAction } from "melco-shared-logic";

export const useDeleteDesigns = () => {
  const [deleteDesign] = useAPIAction(
    DesignsDraftApi,
    async (api, id: string) => {
      const data = await api.userDesignsDelete({ id, force: true });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "designs.actions.delete",
    }
  );

  return useCallback(
    async (designIds: string[]) => {
      const successfullyDeleted: string[] = [];

      for (const designId of designIds) {
        try {
          await deleteDesign(designId);
          successfullyDeleted.push(designId);
        } catch (e) {
          // error handling is already done in useAPIAction
        }
      }

      return successfullyDeleted;
    },
    [deleteDesign]
  );
};
